module.exports = __webpack_public_path__ + "ins06.png?4e61864fc102026a72a0387c4395b437";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/ins06.png
// module id = 157
// module chunks = 0